import { useTranslation } from 'react-i18next';
import { env } from '@/config/env';

/**
 * Slim, quiet, and out of the way. The old footer was a 64px black bar on every
 * page — on a phone that is a tenth of the viewport spent on a copyright line.
 */
export function AppFooter() {
  const { t } = useTranslation();

  return (
    <footer className="text-muted-foreground flex flex-col items-center justify-between gap-2 border-t px-4 py-3 text-xs sm:flex-row">
      <p>{t('shell.footerRights', { year: new Date().getFullYear() })}</p>
      {/* Support and Documentation used to link here; both pages are gone
          (Help was an unused feature) and a footer full of dead links is worse
          than a footer with none. */}
      <span className="tabular-nums opacity-60">{env.prefix}</span>
    </footer>
  );
}
